import { createAction } from 'redux-starter-kit';

/**
 * An action to store a search result in the state.
 * @param object payload The inspection summary object.
 */
export const putInspectionSummary = createAction('PUT_INSPECTION_SUMMARY');

/**
 * An action to store multiple inspection summary objects in the state.
 * @param array An array of inspection summary objects.
 */
export const setInspectionSummaries = createAction('PUT_INSPECTION_SUMMARIES');
